/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  mutation SmppMultiCreateMutation(
    $customerId: ID!
    $displayName: String!
    $ip: [String!]!
    $username: String!
    $enableLossProtection: Boolean
    $isLocalHlr: Boolean
    $password: String!
    $sessionTimeoutInterval: Float!
    $sessionAllowed: Int
    $tps: Int
    $enquireLinkInterval: Float!
    $trunkType: TRUNK_TYPE!
    $debuggingLevel: SMPP_DEBUGGING_LEVEL!
    $batchId: String!
    $chargeOnDelivered: Boolean
  ) {
    SmppMultiCreate(
      customerId: $customerId
      displayName: $displayName
      ip: $ip
      username: $username
      password: $password
      sessionTimeoutInterval: $sessionTimeoutInterval
      sessionAllowed: $sessionAllowed
      tps: $tps
      enableLossProtection: $enableLossProtection
      isLocalHlr: $isLocalHlr
      enquireLinkInterval: $enquireLinkInterval
      trunkType: $trunkType
      debuggingLevel: $debuggingLevel
      batchId: $batchId
      chargeOnDelivered: $chargeOnDelivered
    ) {
      data
      message
      status
    }
  }
`;
